// extracted by mini-css-extract-plugin
module.exports = {"container":"_a9cdce2","detailContainer":"_b65aaa2","detail":"_6af50cc","label":"_3d2cd56","value":"_cee161d"};